<script lang="ts" setup>
import { ref, watch, getCurrentInstance } from "vue";
import { getHomeTypes } from "@/services/api/chart.api";
import ChartHomeTypes from "@/components/app/charts/ChartHomeTypes.vue";
import { useToast } from "vue-toastification";
import { useUserStore } from "@/stores/user";

const props = defineProps({
  token: {
    type: String,
  },
  compact: {
    type: Boolean,
    default: false,
  },
});

const userStore = useUserStore();

const buildingFunctions = ref({});
const isLoading = ref(true);
const toaster = useToast();

watch(
  () => props.token,
  () => {
    fetchBuildingFunctionsData();
  },
  { immediate: true }
);

async function fetchBuildingFunctionsData() {
  isLoading.value = true;
  const response = await getHomeTypes(props.token);
  if (response) {
    buildingFunctions.value = {};
    buildingFunctions.value["Eengezins"] = { val: response.data.houses, color: "#00a86b" }; // Jade
    buildingFunctions.value["Woningen in een appartementencomplex"] = { val: response.data.apartments, color: "#000080" }; // Navy blue
    isLoading.value = false;
  } else {
    isLoading.value = false;
    toaster.error("Ophalen van de buildingFunctions data is mislukt!");
  }
}
</script>

<template>
  <div class="widget-item" :class="{ 'widget-item--compact': props.compact }">
    <header>
      <h2>Overzicht complexen</h2>
      <div class="widget-actions">
        <router-link v-if="!props.compact" :to="{ name: 'ComplexOverview', params: { partyReference: userStore.currentPartyReference } }" class="widget-link">Bekijk totale overzicht</router-link>
        <information-dropdown id="overzicht-panden">
          <p>Uw portefeuille kan bestaan uit verschillende type woningen. We tonen hier de verdeling van de type woningen voor alle complexen.</p>
        </information-dropdown>
      </div>
    </header>
    <loader-spinner v-if="isLoading" :is-loading="isLoading"></loader-spinner>
    <div v-else class="widget-wrapper" :min-height="200">
      <div v-if="props.compact" class="compact-content">
        <div class="widget-chart">
          <chart-home-types :radius="165" :source-data="buildingFunctions"></chart-home-types>
        </div>
      </div>
      <div v-else class="widget-chart">
        <chart-home-types :radius="200" :source-data="buildingFunctions"></chart-home-types>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.widget-item--compact .widget-wrapper {
  flex: 1;
  min-height: 0;
  margin-top: 4px;
}

.widget-item--compact .compact-content {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  min-height: 0;
  gap: 8px;
}

.widget-item--compact .widget-chart {
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.widget-item--compact :deep(.vue-chart .vue-chart-legend) {
  margin: 12px;
  width: 150px;
}

.widget-item--compact :deep(.advanced-doughnut) {
  width: auto;
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
}

.widget-item--compact :deep(.doughnut) {
  flex: 0 0 auto;
}

.widget-item--compact :deep(.legend-items) {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  width: auto;
}

.widget-item--compact :deep(.legend-item) {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-size: 0.82rem;
}
</style>
